import { Box, Button } from "@material-ui/core";
import strings from "../../constants/StringConstants";
import customButtonStyles from "./CustomButton.styles";
import glydeWhiteGif from "../../../assets/icons/glyde-loading-white.gif";
import glydeTealGif from "../../../assets/icons/glyde-loading.gif";
import clsx from "clsx";
import GlydeBackdrop from "../../../screens/Shared/Backdrop";

interface CustomProps {
  label: string;
  onClick: Function;
  loading?: boolean;
  customClasses?: string;
  disabled?: boolean;
  tealLoading?: boolean;
  additionClass?: string;
}

const CustomButton = (props: CustomProps) => {
  const classes = customButtonStyles();
  const appliedClass = props.customClasses
    ? props.customClasses
    : classes.btnStyle;
  const processing = props.loading ? props.loading : false;
  const disabled = props.disabled ? props.disabled : false;

  const isbackDrop = [
    "Apply",
    "Start Tab",
    "Pay Now",
    "Remove",
    "Start a Tab",
    "Close Tab",
  ].includes(props.label);

  return (
    <>
      {processing && isbackDrop && <GlydeBackdrop isLoading={processing} />}
      <Button
        className={clsx(props.additionClass, {
          [appliedClass]: !disabled,
          [classes.disabledBtnStyle]: disabled,
        })}
        onClick={() => {
          !processing && props.onClick();
        }}
        disabled={disabled}
      >
        {processing && !isbackDrop ? (
          <Box className={classes.loading}>
            <img
              src={props.tealLoading ?? false ? glydeTealGif : glydeWhiteGif}
              alt={strings.glydeLoadingImage}
              className={classes.glydeGif}
            />
          </Box>
        ) : (
          props.label
        )}
      </Button>
    </>
  );
};

export default CustomButton;
